import { useContext } from "react";
import "./SquareDetails.css";
import { MainContext } from "../App";
import { WorldHandler } from "../controllers/world";
import { CharacterState } from "../controllers/characters";
import { ResourceNodeState, ResourceType } from "../controllers/resources";
import { Row, Col, Statistic } from "antd";
import CharacterRow from "./CharacterRow";
import { FactionType, SocialHandler } from "../controllers/social";

const SquareDetails = () => {
  const { appState: context } = useContext(MainContext);

  let characters: CharacterState[] = [];

  if (context.view.squareHighlighted) {
    //const sortByFamily = SocialHandler.sortByFaction(FactionType.FAMILY, "factionName");
    const sortByPosInfluence = SocialHandler.sortByFaction(
      FactionType.POS,
      "influence",
      true
    );

    characters = WorldHandler.getAllCharactersAtPos(
      context.view.squareHighlighted,
      context.world
    ).sort(sortByPosInfluence);

    /*
    const influenceByFamily = SocialHandler.getFactionInfluences(
      FactionType.FAMILY,
      characters,
      context.world.factions,
      FactionType.POS
    );
    console.log(
      "influenceByFamily",
      influenceByFamily.map((e) => [e.factionName, e.influence])
    );
    */
  }

  const getResourceQuantityStr = (resource: ResourceType): string => {
    if (!context.view.squareHighlighted) {
      return "";
    }

    const resNode: ResourceNodeState | undefined =
      WorldHandler.getAllResourceNodesAtPos(
        context.view.squareHighlighted,
        context.world
      ).find((r) => r.resource === resource);

    if (!resNode) {
      return "";
    }

    return `${resNode.quantity}`;
  };

  return (
    <div className="square-details">
      <div>
        {context.view.squareHighlighted ? (
          <div>
            <Row gutter={16}>
              <Col span={8}>
                <Statistic
                  title="Pos"
                  value={WorldHandler.posStr(context.view.squareHighlighted)}
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="Food"
                  value={getResourceQuantityStr(ResourceType.FOOD)}
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="Preys"
                  value={getResourceQuantityStr(ResourceType.ANIMAL_PREY)}
                />
              </Col>
            </Row>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="square-details-characters">
        {characters.map((c) => (
          <CharacterRow key={`child-row-${c.id}`} character={c} />
        ))}
      </div>
    </div>
  );
};

export default SquareDetails;
